import Home from '@/views/Home/English/Home.vue'
// import Super_yachts from "@/views/Super_yachts/English/Super_yachts.vue"
// import Water_sports from "@/views/Water_sports/English/Water_sports.vue"
// import Fishing from "@/views/Fishing/English/Fishing.vue"
// import Tours from "@/views/Tours/English/Tours.vue"
// import Terms from '@/views/Terms/English/Terms.vue';
// import Policy from '@/views/Policy/English/Policy.vue';
// import Company from "@/views/Company/English/Company.vue"
// import News from "@/views/News/English/News.vue"
// import Office from "@/views/Office/English/Office.vue"
// import Fun from "@/views/Fun/English/Fun.vue"
import { children } from '@/lang/zh'
// 英文语言路由表
export default [
    // {
    //     path: '/english/home',
    //     component: Home,
    // },
    {
        path: '/english/yachtTours',
        component: () => import('@/views/Tours/English/Tours.vue'),
    },
    {
        path: '/english/superYachts',
        component: () => import('@/views/Super_yachts/English/Super_yachts.vue'),
    },
    {
        path: '/english/waterSports',
        component: () => import('@/views/Water_sports/English/teach.vue'),
    },
    {
        path: '/english/bookOrder',
        component: () => import('@/views/Fun/English/Fun.vue'),
    },
    {
        path: '/english/news',
        component: () => import('@/views/News/English/News.vue'),
        children: [
            {
                path: '',
                component: () => import('@/views/News/English/defaultPage.vue'),
                meta: { detail: true },
            },
            {
                path: 'detail',
                component: () => import('@/views/News/English/newsDetail.vue'),
                meta: { detail: true },
            },
        ],
    },
    {
        path: '/english/contact',
        component: () => import('@/views/Office/English/Office.vue'),
    },
    {
        path: '/english/fishing',
        component: () => import('@/views/Fishing/English/Fishing.vue'),
    },
    {
        path: '/english/team',
        component: () => import('@/views/Company/English/Company.vue'),
    },

    // {
    //     path: '/english/OrderManagement',
    //     redirect: '/english/OrderManagement/QuickOrder',
    //     component: () => import('@/views/OrderManagement/English'),
    //     children: [
    //         {
    //             path: 'QuickOrder',
    //             name: 'EQuickOrder',
    //             component: () => import('@/views/OrderManagement/Charter'),
    //             // component: () => import("@/views/OrderManagement/English/QuickOrder"),
    //             meta: {
    //                 name: 'quickOrder',
    //             },
    //         },
    //         {
    //             path: 'Management',
    //             name: 'EManagement',
    //             component: () => import('@/views/OrderManagement/English/Management'),
    //             meta: {
    //                 name: 'Management',
    //             },
    //         },
    //     ],
    // },
    // {
    //     path: '/english/OrderManagement/CharterOrder',
    //     name: 'ECharterOrder',
    //     component: () => import('@/views/OrderManagement/Charter/quickOrder'),
    //     // component: () => import("@/views/OrderManagement/English/QuickOrder"),
    //     meta: {
    //         name: 'CharterOrder',
    //     },
    // },
]
